import './index_mWeb.css';
import FlatList from 'flatlist-react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../actions/app-actions-types';
import { FlatListWrapper, View } from '../../../component';
import { getRouteObjByGame } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import I18n from '../../../utilities/locale';
import TeamBoxMWeb from '../../component/team_box/index_mWeb';
import { useLink } from 'react-router-stack';
import Button from '@mui/material/Button/Button';
import React from 'react';

const MyTeamsListMWeb = ({
  myTeamList,
  onPressPreview,
  onPressClone,
  onPressEdit,
  lineupsOut,
  title,
  matchAllPlayersList,
  contestTeams,
  gameType,
  tabType
}: any) => {
  const navigate = useLink();

  const { item: matchItem, fantasyMatchClick } = useGame();

  const dispatch = useDispatch();
  const totalTeamsCount = myTeamList.length;

  const renderItem = (item: any) => {
    return (
      <TeamBoxMWeb
        selectTeamByUser={() => {}}
        joinedMatch={false}
        item={item}
        key={item.matchTeamId}
        onPressPreview={onPressPreview}
        onPressClone={onPressClone}
        onPressEdit={onPressEdit}
        onPressAlreadyJoin={() => {}}
        lineupsOut={lineupsOut}
        title={title}
        matchAllPlayersList={matchAllPlayersList}
        contestTeams={contestTeams}
        tabType={tabType}
        gameType={gameType}
      />
    );
  };

  const onPressAddTeam = () => {
    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            isFromCreateTeamButton: true,
            selectedTeamPlayers: [],
            teamData: {
              teamNumber: totalTeamsCount + 1
            },
            isEdit: false,
            isClone: false
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const addTeamBtnColor: any = {
    backgroundImage: 'linear-gradient(to bottom, #f6c53f, #ffc300)',
    border: `solid 1px #fff079`,
    shadowColor: '#FFD84A',
    color: '#000',
    fontFamily: 'ProximaNova-Bold',
    width: '150px',
    textTransform: 'none'
  };

  return (
    <React.Fragment>
      <View>
        {/* <PullToRefresh onRefresh={onRefresh}> */}
        <FlatListWrapper
          style={{
            paddingBottom: '170px'
          }}>
          <FlatList
            list={myTeamList}
            renderItem={renderItem}
            renderOnScroll
            // renderWhenEmpty={renderWhenEmpty}
          />
        </FlatListWrapper>
        {/* </PullToRefresh> */}
      </View>
      {totalTeamsCount < 11 && myTeamList.length !== 0 && (
        <View className={'my-team-list-create-button-container_mWeb'}>
          <Button
            className={'my-team-list-create-button_mWeb'}
            onClick={onPressAddTeam}
            style={addTeamBtnColor}>
            {I18n.t('createTeam')}
          </Button>
        </View>
      )}
    </React.Fragment>
  );
};

export default MyTeamsListMWeb;
